/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react'
import { shape, func, bool } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import CMSRenderer from 'components/cms/CMSModules'
import BodyClass from 'components/body-class'
import MobileProfile from 'components/MobileProfile'
import Button from 'common/components/button'
import * as profileActions from 'services/app-state/profile/actions'
import Icon from 'common/components/icon'
import { getRequestOriginFromUrl } from 'services/utility'
import { ACCOUNT_LINK, CUST_HELP_URL } from 'services/utility/constants'
import './navigation.scss'

export const SecondaryNav = (props) => {
  const {
    ui: { leftNavOpen: isOpen },
    pageContent: data,
    dispatch,
    ui,
    signOut,
    isSignedIn,
    ...rest
  } = props
  const [loading, setLoading] = useState(false)
  const signOutClickHandler = () => {
    setLoading(true)
    signOut().then(() => dispatch({ type: 'TOGGLE_NAV' }))
  }
  const isBabyClubHeader = getRequestOriginFromUrl() === 'btc'
  return (
    <BodyClass noScroll={isOpen}>
      { isOpen ? <div className="background-shadow" /> : null }
      { isOpen ? (
        <Button
          className="menu-close"
          isIcon
          clickHandler={() => dispatch({ type: 'TOGGLE_NAV' })}
        >
          <Icon
            name="close"
            size="large"
            color="white"
          />
        </Button>
      ) : null }
      <nav className={isOpen ? 'main-nav open' : 'main-nav'}>
        <MobileProfile isBabyClubHeader={isBabyClubHeader} />
        <div className="main-nav-section">
          {data ? (
            <CMSRenderer {...rest} contents={data.secondaryNav} ui={ui} />
          ) : null}
          <ul className="extended-menu">
            <li className="custom-link">
              <a className="" href={CUST_HELP_URL}>
                Help
              </a>
            </li>
            { isSignedIn ? (
              <li className="custom-link">
                <a className="" href={ACCOUNT_LINK}>
                  Account
                </a>
              </li>
            ) : null}
          </ul>
        </div>
        {
          isSignedIn ? (
            <div className="main-nav__footer">
              <Button
                clickHandler={signOutClickHandler}
                className="asda-btn--fluid"
                category="secondary"
                loading={loading}
              >
                Sign out
              </Button>
            </div>
          ) : null
        }
      </nav>
    </BodyClass>
  )
}

SecondaryNav.propTypes = {
  ui: shape({
    leftNavOpen: bool,
  }).isRequired,
  pageContent: shape({}).isRequired,
  dispatch: func.isRequired,
  signOut: func.isRequired,
  isSignedIn: bool.isRequired,
}

const mapStateToProps = ({ profile }) => ({
  isSignedIn: profile.isSignedIn,
})

const mapDispatchToProps = dispatch => ({
  signOut: bindActionCreators(profileActions.signOut, dispatch),
  dispatch,
})

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryNav)



// WEBPACK FOOTER //
// ./components/secondary-nav/index.js